module.exports = __webpack_public_path__ + "8b293d984cea7db72e62598083dc759d.svg";